import React, { useState, useEffect } from "react";
import { ReactDOM } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './Login.css';
// import { checkUserAccess } from "./Services/CommonLibrary";


const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [setImg, setSetImg] = useState("");
  const [user, setUser] = useState("");
  const [otp, setotp] = useState("");
  const [showotp, setShowotp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const nav = useNavigate();
  let isLoggedIn = localStorage.getItem('user');

  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: 'danger',
    msg: ''
  });
  const { visible, cls } = alertInfo;

  const onShowAlert = (msg) => {
    setAlertInfo({ ...alertInfo, ['visible']: true, ['msg']: msg });
  }


  const loginNavigate = () => {
    nav('/login')
  }

  useEffect(() => {

    const domainName = window.location.hostname;
    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/company_logo', {
      domain: domainName
    })
      .then(function (response) {
        console.log(response.data.data.logo);
        setSetImg(response.data.data.logo);
      })
      .catch(function (error) {
        console.log(error);
      });

    if (isLoggedIn > 0) {
      // alert(isLoggedIn);
      return nav('/program-list');
      // return <div>{user.name} is loggged in</div>;
    }
  }, []);

  // const handleSubmit = async e => {
  //   e.preventDefault();
  //   // var formdata = new FormData();
  //   // //add three variable to form
  //   // formdata.append("accessEmail", username);
  //   // formdata.append("accessPassword", password);
  //   // formdata.append("accessType", "superadmin");
  //   // const response = await axios.post(
  //   //   "https://coachnhsapiv2.goqii.com/nhspatientmanagement/user_login?",formdata);

  //   axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/user_login', {
  //     accessEmail: username,
  //     accessPassword: password
  //   })
  //     .then(function (response) {
  //       // alert("call");
  //       console.log(response.data)
  //       //set the state of the user
  //       if (response.data.status == "1") {
  //         setUser(response.data)
  //         //  console.log(response.data.data.pmsUserId);
  //         // store the user in localStorage
  //         localStorage.setItem('uid', response.data.data.pmsUserId)
  //         localStorage.setItem('user', response.data.data.validUser)
  //         localStorage.setItem('authToken', response.data.data.verificationToken)
  //         localStorage.setItem('access', response.data.data.access)
  //         localStorage.setItem('isTestUser', response.data.data.isTestUser)
  //         localStorage.setItem('accessTab', response.data.data.tabs)

  //         return nav('/program-list');
  //         //  console.log(response.data)
  //       } else if (response.data.status == "0") {
  //         onShowAlert(response.data.data.message);
  //         // console.log()
  //       }

  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });



  // };

  const handleSubmit = async e => {
    e.preventDefault();
    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/send_otp', {
      userName: username,
    })
      .then(function (response) {
        console.log(response.data.code, "response")
        if (response.data.code === 200) {
          setShowotp(true)
          setAlertInfo({ ...alertInfo, ['visible']: false, ['msg']: '' });
        } else {
          onShowAlert("Invalid Username");
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  };


  const handleOtp = async e => {
    e.preventDefault();
    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/verify_otp', {
      userName: username,
      otp: otp
    })
      .then(function (response) {
        console.log(response.data, "response")
        if (response.data.code === 200) {
          setShowPassword(true)
          setAlertInfo({ ...alertInfo, ['visible']: false, ['msg']: '' });
        } else {
          onShowAlert("Invalid OTP");
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handlePasswordReset = async e => {
    e.preventDefault();
    if (password !== confirmPassword) {
      onShowAlert("Passwords do not match");
      return;
    }

    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/update_password', {
      userName: username,
      password: password,
      confirmPassword: confirmPassword
    })
      .then(function (response) {
        if (response.data.code === 200) {
          alert("Password reset successfully");
          setTimeout(() => {
            nav('/login');
          }, 2000);
        } else {
          onShowAlert("Invalid Email or Password");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // if there's a user show the message below

  if (isLoggedIn > 0) {
    // alert(isLoggedIn);
    return nav('/program-list');
    // return <div>{user.name} is loggged in</div>;
  }



  // if there's no user, show the login form
  return (
    <section className="nhs-login-page">
      <div className="container">
        <div className="content">
          <div className="row">

            <div className="col-12 mb-5 text-center">
              <h1>Password Recovery</h1>
            </div>
            <div className="card px-0">
              <div className="card-body">
                <div className="row mb-5">
                  <div className="col-6 text-start">
                    <img src={("https://appcdn.goqii.com/storeimg/36561_1672304537.png")} alt="" style={{ height: "34px" }} className="img-fluid" />
                  </div>
                  <div className="col-6 text-end">
                    <img src={setImg} alt="" style={{ height: "34px" }} className="img-fluid" />
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  {visible ?
                    <div className={"text-" + alertInfo.cls + " form-floating mb-3"} role="alert">
                      {alertInfo.msg}
                    </div> : null}

                  {showPassword ? (
                    <>
                      <div className="form-floating mb-3">
                        <input
                          type="password" required
                          value={password}
                          placeholder="Enter new password"
                          className="form-control"
                          onChange={({ target }) => setPassword(target.value)}
                        />
                        <label>Enter new password</label>
                      </div>
                      <div className="form-floating mb-3">
                        <input
                          type="password" required
                          value={confirmPassword}
                          placeholder="Confirm new password"
                          className="form-control"
                          onChange={({ target }) => setConfirmPassword(target.value)}
                        />
                        <label>Confirm new password</label>
                      </div>
                      <button onClick={handlePasswordReset} className="btn btn-primary btn-login mb-3">Reset Password</button>
                    </>
                  ) : showotp ? (
                    <>
                      <div className="form-floating mb-3">
                        <input
                          type="text" required
                          value={otp}
                          placeholder="Enter OTP"
                          className="form-control"
                          onChange={({ target }) => setotp(target.value)}
                        />
                        <label>Enter OTP</label>
                      </div>
                      <button onClick={handleOtp} className="btn btn-primary btn-login mb-3">Submit OTP</button>
                    </>
                  ) : (
                    <>
                      <div className="form-floating mb-3">
                        <input
                          type="text" required
                          value={username}
                          placeholder="Enter your Username"
                          className="form-control"
                          onChange={({ target }) => setUsername(target.value)}
                        />
                        <label>Enter your Username to reset your password</label>
                      </div>
                      <button type="submit" className="btn btn-primary btn-login mb-3">Submit</button>
                    </>
                  )}
                  {/* <div className="form-floating mb-3">
                    <input
                      type="text" required
                      value={username}
                      placeholder="Enter your email address"
                      className="form-control"
                      onChange={({ target }) => setUsername(target.value)}
                    />
                     <label >Enter your email address to reset your password</label>
                  </div>
                  <button type="submit" className="btn btn-primary btn-login mb-3">Submit</button> */}
                </form>
                <div className="row">
                  <div className="col-12 text-center center">
                    <div style={{ color: '#4e52d0', lineHeight: '50px', cursor: 'pointer' }} onClick={loginNavigate}><b>Return to Login Page</b></div>
                  </div>
                  <div className="col-12 text-center center">
                    By signing in, I accept GOQii's <a href="https://goqii.com/terms.html" target="_blank" style={{ color: '#4e52d0', fontWeight: '500' }} >Terms of Service</a> and <a href="https://goqii.com/in-en/privacypolicy" target="_blank" style={{ color: '#4e52d0', fontWeight: '500' }}>Privacy Policy</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;